<template>
  <BaseModal overlay-class="other_modals modal_text">
    <div class="content">
      <BaseImage src="/static/images/other/text_icon.svg" alt="Text Icon" />

      <h3 class="title">{{ $_translations.value.modal_bonus_game_already_played_title }}</h3>

      <p>{{ $_translations.value.modal_bonus_game_already_played_description }}</p>

      <BaseButton
        button-class="fancy_btn close_modal"
        @click:button="$emit('redirect:homePage')"
      >
        {{ $_translations.value.modal_bonus_game_already_played_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';

defineEmits(['redirect:homePage']);
</script>
